import { ThemeEnum } from '../../enum/Theme';
import { BaseResponse } from './BaseResponse';

export interface ApplicationConfig {
  timeZone?: string;
  rowDensity?: number;
  theme?: ThemeEnum;
}

export interface ConfigResponse extends BaseResponse {
  Config: ApplicationConfig;
}

export function mergeConfigs(
  baseConfig: ApplicationConfig,
  overrideConfig: Partial<ApplicationConfig>,
): ApplicationConfig {
  const filteredOverrides = Object.fromEntries(
    Object.entries(overrideConfig).filter(([_, v]) => v != null),
  ) as Partial<ApplicationConfig>;

  return { ...baseConfig, ...filteredOverrides };
}
